//
import { createStore, applyMiddleware, combineReducers } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';


// Login Reducer
import login from './reducers/login/login.reducer';
import reset_password from './reducers/reset/reset.reducer';
import company from './reducers/company/company.reducer';
import department from './reducers/department/department.reducer';
import designation from './reducers/designation/designation.reducer';
import leave_type from './reducers/leave_type/leave_type.reducer';
import employee from './reducers/employee/employee.reducer';
import register from './reducers/register/register.reducer';
import employeeedit from './reducers/employee.edit/employee.edit.reducer';
import holiday from './reducers/holiday/holiday.reducer';
import leave from './reducers/leave/leave.reducer';
import approval from './reducers/approvals/approvals.reducer';
import permission from './reducers/permission/permission.reducer';
import meetings from './reducers/meetings/meetings.reducer';
import reports from './reducers/reports/reports.reducer';
import print from './reducers/prints/prints.reducer';
import asset from './reducers/assets/asset.reducer';
import travel from './reducers/travel/travel.reducer';
import summary from './reducers/summary/summary.reducer';
import leave_admin from './reducers/leaves_admin/leaves_admin.reducer';
import compleave from './reducers/compassionate/compassionate.reducer';
import resignation from './reducers/resignation/resignation.reducer';
import checklist from './reducers/check_list/checklist.reducer';
import letter from './reducers/letter/letter.reduce';
import onboard from './reducers/onboarding/onboard.reducer';
import hr_meetings from './reducers/hr_reports/hr_reports.reducer';
import expense from './reducers/expense/expense.reducer';
import ind_carryforward from './reducers/ind_carryforward/carry.reducer';

const rootReducer =  combineReducers({
	ind_carryforward,
	login,
	leave_type,
	leave,
	reset_password,
	register,
	company,
	department,
	designation,
	employee,
	employeeedit,
	holiday,
	approval,
	permission,
	meetings,
	reports,
	print,
	asset,
	travel,
	summary,
	leave_admin,
	compleave,
	resignation,
	checklist,
	letter,
	onboard,
	hr_meetings,
	expense
});


export default createStore( rootReducer, composeWithDevTools( applyMiddleware( thunk ) ) );



// WEBPACK FOOTER //
// ./src/store/store.js